export enum YesNoRadioOptions {
  YesOption = "YesOption",
  NoOption = "NoOption",
}
